import "./style.scss";

import Plus from "assets/img/svg/plus";

import StyledButton from "../StyledButton";

/**
 * Render an informative empty state blue popup with an action button.
 */
interface IEmptyPopState {
    title: string;
    description: string;
    btnTxt: string;
    onSubmit: () => void;
}

const EmptyPopState = ({ title, description, btnTxt, onSubmit }: IEmptyPopState) => {
    return (
        <div className="empty-state-with-action">
            <h3>{title}</h3>
            <span>{description}</span>
            <StyledButton buttonType="primary" sx={{ width: "max-content" }} onClick={onSubmit}>
                <Plus />
                {btnTxt}
            </StyledButton>
        </div>
    );
};

export default EmptyPopState;
